import { Routes, Route, Navigate } from 'react-router';
import {
  Activate,
  PasswordSent,
  Pending,
  ResetPassword,
  ResetSuccess,
} from '@/features/auth';
import { CreateAd } from '@/pages/ad-pages';
import { PartnerHome } from '@/pages/partner-home';
import { AdDetails } from '@/pages/ad-details';
import { Profile } from '@/pages/profile';
import { InReview } from '@/pages/in-review/InReview';
import { NotFoundPage } from '@/pages/not-found-page';
import { Campaigns } from '@/pages/campaigns';
import { PartnerPayments } from '@/pages/partner-payments';
import { AuthLayout } from './layouts/AuthLayout';
import { Main } from '@/pages/main/Main';
import { ClientLayout } from './layouts/ClientLayout';
import { PartnerLayout } from './layouts/PartnerLayout';
import { LoginPage } from '@/pages/login';
import { RegisterPage } from '@/pages/register';
import { ResetPasswordPage } from '@/pages/reset-password';
import { WalletPage } from '@/pages/wallet-page';
import { RootRedirect } from '@/features/navigation/RootRedirect';
import { CampaignDetails } from '@/pages/campaign-details';
import { MaintenancePage } from '@/pages/maintenance';
import { PaymentDetails } from '@/pages/payment-details/PaymentDetails';

const isMaintenanceMode = false;

export const Navigation = () => {
  // Redirect to maintenance page if maintenance mode is enabled
  if (isMaintenanceMode) {
    return (
      <Routes>
        <Route element={<AuthLayout />}>
          <Route path="/maintenance" element={<MaintenancePage />} />
          <Route path="*" element={<Navigate to="/maintenance" replace />} />
        </Route>
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<RootRedirect />} />

      <Route element={<AuthLayout />}>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/pending" element={<Pending />} />
        <Route path="/forgot-password" element={<ResetPasswordPage />} />
        <Route path="/activate" element={<Activate />} />
        <Route path="/reset-link-sent" element={<PasswordSent />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/reset-success" element={<ResetSuccess />} />
      </Route>

      <Route element={<ClientLayout />}>
        <Route path="client">
          <Route index element={<Main />} />
          <Route path="campaigns" element={<Campaigns />} />
          <Route path="review/ads" element={<InReview />} />
          <Route path="create/ad" element={<CreateAd />} />
          <Route path="details/ad/:id" element={<AdDetails />} />
          <Route path="details/campaign/:id" element={<CampaignDetails />} />
          <Route path="profile" element={<Profile />} />
          <Route path="wallet" element={<WalletPage />} />
        </Route>
      </Route>

      <Route element={<PartnerLayout />}>
        <Route path="partner">
          <Route index element={<PartnerHome />} />
          <Route path="payments" element={<PartnerPayments />} />
          <Route path="payments/:id" element={<PaymentDetails />} />
          <Route path="profile" element={<Profile />} />
        </Route>
      </Route>

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};
